export default {
  SET_NEW_USER(state, newUser) {
    // Basically, if you're not setting this explicitly to false,
    // then it should default to true.
    if (newUser.emailInvoice !== false) {
      newUser.emailInvoice = true;
    }
    let user = {
      ...defaultState,
      ...newUser,
    }
    state.newUser = user;
  },
  SET_NEW_USER_ACLS(state, newUserACLs) {
    state.newUserACLs = newUserACLs;
  },
  SET_USER(state, user) {
    if (!user.userId) {
      console.warn('invalid user id in payload');
      return;
    }

    if (!user.user) {
      console.warn('invalid user in payload');
      return;
    }

    if (user.user.countryCode === 'null') user.user.countryCode = 'US';
    if (user.user.phone === 'null') user.user.phone = '';
    if (user.user.phoneType === 'null') user.user.phoneType = '';

    state.users[user.userId] = user;
  },
  SET_USER_ROLE(state, userRole) {
    if (!userRole.userId) {
      console.warn('invalid user id in payload');
      return;
    }
    if (!userRole.userRole) {
      console.warn('invalid user role in payload');
      return;
    }

    state.userRoles[userRole.userId] = userRole;
  },
  CLEAR_USER_AND_ROLES(state, userId) {
    if(state.users[userId]) {
      delete state.users[userId];
    }
    if(state.userRoles[userId]) {
      delete state.userRoles[userId];
    }
  }
};
